/**
 * Async function, checks for condition until it is resolved with true
 */
export function until(conditionFunction: () => boolean, ms = 400, timeoutMs?: number): Promise<undefined> {
  const startedAt = Date.now();
  const poll = (resolve, reject) => {
    if (conditionFunction()) {
      resolve();
    } else if (timeoutMs && Date.now() - startedAt >= timeoutMs) {
      reject(new Error("Condition wait timeout exceeded"));
    } else {
      setTimeout(() => poll(resolve, reject), ms);
    }
  };

  return new Promise(poll);
}
